import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useInitiateSiteSwitchLogMutation, useNavigateToClassicCastleMutation, useLoginWithGoogleOneTapMutation } from '../../features/authentication/authApiSlice';
import { setCredentials } from '../../features/authentication/authSlice';
import { useDispatch } from 'react-redux';
import { useGoogleOneTapLogin } from '@react-oauth/google';
import { getTimezoneOffset } from '../../utils/Timezoneoffset';

export default function Index() {
  const navigate = useNavigate();
  const [loginWithGoogle] = useLoginWithGoogleOneTapMutation();
  const [navToClassic] = useNavigateToClassicCastleMutation();
  const [initialiseSiteSwitchLog] = useInitiateSiteSwitchLogMutation();
  const [errorMessage, setErrorMessage] = useState('Redirecting...');
  const dispatch = useDispatch();
  const reWriteUrl = useRef('');
  const queryParams = new URLSearchParams(location.search);
  const url = queryParams.get('url');
  const gc = queryParams.get('gc');

  useGoogleOneTapLogin({
    onSuccess: async response => {
      try {
        let tzo = await getTimezoneOffset();
        const authResponse = await loginWithGoogle({Token: response.credential, TimeZoneOffset: tzo}).unwrap();

        dispatch(setCredentials({ accessToken: authResponse.accessToken }));

        if (!authResponse.isSuccess && authResponse.reason === 'SuperAdminAccessRequired') {
          navigate('superAdminLogin');
        } else if (authResponse.redirectUrl) {
          await redirectToClassic(authResponse);
        } else {
          if (url && authResponse.redirectUrl) {
            await redirectToClassic(authResponse);
            return;
          }
          navigate('/dashboard');
        }
      } catch (ex) {
        if (!ex?.status || ex.status === 'FETCH_ERROR') {
          setErrorMessage('No server response');
        } else if (ex?.data?.reason) {
          setErrorMessage(ex.data.reason);
        } else {
          setErrorMessage('Login was unsuccessful');
        }
      }
    },
    onError: () => setErrorMessage('Failed to login with Google account.')
  });

  const redirectToClassic = async (authResponse) => {
    var options = {
      reWriteUrl: authResponse.redirectUrl,
      selectedCenter: authResponse.redirectUrl.includes('AdminHome')
        ? 'AdminHome'
        : authResponse.redirectUrl.includes('TeacherHome')
          ? 'TeacherHome'
          : 'StudentHome'
    };
    if (url) options.urlGuid = url;
    if (gc) options.isGoogleClassroom = true;

    const response = await navToClassic(options);
    if (response.error) {
      setErrorMessage(response.error.data.error);
    } else {
      reWriteUrl.current = response.data.returnUrl;
      await handleSiteSwitchLog();
    }
  };

  const handleSiteSwitchLog = async () => {
    try {
      var response = await initialiseSiteSwitchLog();
      window.location.href = reWriteUrl.current + '&logId=' + response.data;
    } catch (ex) {
      console.log(ex);
    }
  };

  return <>{errorMessage}</>;
}
